import { render, staticRenderFns } from "./CalendarWebpart.vue?vue&type=template&id=3f23a890"
import script from "./CalendarWebpart.ts?vue&type=script&lang=ts&external"
export * from "./CalendarWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports